import { render } from "./suivicommande.vue?vue&type=template&id=54c7c68d"
import script from "./suivicommande.vue?vue&type=script&lang=ts"
export * from "./suivicommande.vue?vue&type=script&lang=ts"
script.render = render

export default script